<script setup lang="ts">
import { computed } from "vue";

// shared
import Home from "@/shared/components/atomic/svgs/home/Home.vue";
import { isSusimdalClassAcademy } from "@/shared/config/const/susimdalClassAcademyIds";
import { usePopupManager } from "@/shared/composables/usePopupManager";

// entities
import useAuthenticationStore from "@/entities/user/infrastructure/userStore";

// widgets
import SeminarModeTogglePopup from "@/widgets/navigation/ui/SeminarModeTogglePopup.vue";

const authenticationStore = useAuthenticationStore();
const { openPopup } = usePopupManager();

const isClickableAcademy = computed(() =>
    isSusimdalClassAcademy(authenticationStore.authState.academyId),
);

const openSeminarModePopup = () => {
    if (!isClickableAcademy.value) {
        return;
    }

    openPopup({
        component: SeminarModeTogglePopup,
        props: {
            closeKey: "",
            rest: {},
        },
    });
};
</script>

<template>
    <div
        class="flex gap-3 justify-center items-center bg-white p-xsmall"
        :class="{ 'cursor-pointer': isClickableAcademy }"
        @click="openSeminarModePopup"
    >
        <Home />
        <p class="font-bold text-t-primary text-body-medium font-pretendard">
            {{ authenticationStore.academyName }}
        </p>
    </div>
</template>
